import useOrders from "../hooks/useOrders";

import ActiveOrders from "../components/ActiveOrders";
import PreviousOrders from "../components/PreviousOrders";
import EmptyOrders from "../components/EmptyOrders";

import "./MyOrders.css";

function MyOrders() {

    const {

        loading,

        error,

        activeOrders,

        previousOrders,

        handleCancelOrder,

    } = useOrders();

    if (loading) {

        return (

            <div className="my-orders-loading">

                Loading Orders...

            </div>

        );

    }

    if (error) {

        return (

            <div className="my-orders-error">

                {error}

            </div>

        );

    }

    if (

        activeOrders.length === 0 &&

        previousOrders.length === 0

    ) {

        return <EmptyOrders />;

    }

    return (

        <div className="my-orders-page">

            <div className="my-orders-header">

                <h1>

                    My Orders

                </h1>

                <p>

                    Track your current orders and revisit your previous purchases.

                </p>

            </div>

            {

                activeOrders.length > 0 && (

                    <ActiveOrders

                        orders={activeOrders}

                        onCancel={handleCancelOrder}

                    />

                )

            }

            {

                previousOrders.length > 0 && (

                    <PreviousOrders

                        orders={previousOrders}

                    />

                )

            }

        </div>

    );

}

export default MyOrders;